import AbstractCollection from "./abstractCollection";

class TeamCollection extends AbstractCollection {
  /**
   *
   * @param {Team[]} teams
   */
  constructor(teams) {
    super(teams);
    this.loaded = !!teams;
  }

  /**
   *
   * @returns {Team[]}
   */
  asArray() {
    const teams = this.items;
    teams.sort((a, b) => {
      if (a.fullName === b.fullName) return 0;
      return a.fullName < b.fullName ? -1 : 1;
    });

    return teams;
  }

  /**
   *
   * @param {string} id
   * @param {boolean} [throwError=true]
   * @returns {null|Team}
   */
  getTeamById(id, throwError = true) {
    return this.getItem({ id }, throwError);
  }

  /**
   *
   * @param {string} slug
   * @param {boolean} [throwError=true]
   * @returns {null|Team}
   */
  getTeamBySlug(slug, throwError = true) {
    return this.getItem({ slug });
  }

  /**
   *
   * @param {string} idOrSlug
   * @returns {null|Team}
   */
  getTeamByIdOrSlug(idOrSlug) {
    let team = this.getTeamById(idOrSlug, false);
    if (team) return team;
    return this.getTeamBySlug(idOrSlug);
  }
}

export default TeamCollection;
